import { AxiosError } from 'axios';
import { ConfigurationType } from 'web-library/models/DropDown';
import { GET_EXAM_LEVELS_URL } from '../../constants/apiUrls';
import { GET_EXAM_LEVEL_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: string[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetExamLevel = ({ onError, onSuccess }: Input) => {
  const getExamLevel = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(GET_EXAM_LEVELS_URL);

    return res.data;
  };

  return useCustomQuery([GET_EXAM_LEVEL_QUERY_KEY], getExamLevel, {
    onSuccess,
    onError,
  });
};
